module.exports = __webpack_public_path__ + "img/icon-tu-choi.f5e5e4c4.png";